import { alertNoCalendarEntrySelected, isPrototype } from './global-variables'
import { getTicketAmount, setAmountButtonStates } from './global-functions'
import { toggleFieldsets } from './toggle-fieldset'
import { resetAmountInputs } from './amount-input'
import { fakeSelect } from './section-menu'
import { initModal, showModal } from './modal'

document.addEventListener('handleAmountInputChange', function () {
  setFieldsDependingOnFantissimaTicketAmount()
})

document.addEventListener('resetAmountInputs', function () {
  setFieldsDependingOnFantissimaTicketAmount()
})

document.addEventListener('calendarEntryLoaded', function () {
  const fantissimaSelectMenuSection = document.querySelector('[data-js-select-menu]')
  // execute only once
  const celebrationCheckboxes = fantissimaSelectMenuSection.querySelectorAll('input[id^="celebratecheckbox_"]')
  celebrationCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', function (event) {
      const currentBox = event.target
      if (currentBox.checked) {
        fantissimaSelectMenuSection.querySelector('[data-js-celebration-hint]').removeAttribute('hidden')
      }
    })

    checkbox.addEventListener('click', function (event) {
      const currentBox = event.target
      // if this was previously checked
      if (currentBox.dataset.waschecked === 'true') {
        currentBox.checked = false
        currentBox.dataset.waschecked = 'false'
        fantissimaSelectMenuSection.querySelector('[data-js-celebration-hint]').setAttribute('hidden', 'hidden')
      } else {
        currentBox.dataset.waschecked = 'true'
      }

      // remove was checked from other radios
      celebrationCheckboxes.forEach(function (sibling) {
        if (sibling !== currentBox) {
          sibling.dataset.waschecked = 'false'
        }
      }, this)
    })
  })
})

export const setFieldsDependingOnFantissimaTicketAmount = function () {
  const fantissimaSelectMenuAlert = document.querySelector('[data-js-menu-alert]')
  const fantissimaSelectMenuSection = document.querySelector('[data-js-select-menu]')
  const fantissimaSelectAdditionalOptions = document.querySelector('[data-js-select-additional-options]')
  const selectTicketAlert = document.querySelector('[data-js-ticket-alert]')
  const menuFormRow = document.querySelector('[data-js-menu-form]')

  if (getTicketAmount() > 0) {
    if (alertNoCalendarEntrySelected.hasAttribute('hidden')) {
      fantissimaSelectMenuSection.removeAttribute('hidden')
      selectTicketAlert.setAttribute('hidden', 'hidden')
    }

    const maxValueForAdditionalOptions = getTicketAmount()
    const inputFieldsAdditionalOptions = Array.from(fantissimaSelectAdditionalOptions.querySelectorAll('[data-js-amount-input] input'))

    const groupSums = new Map()
    inputFieldsAdditionalOptions.forEach((input) => {
      const groupContainer = input.closest('[data-js-additional-group]')
      const groupKey = groupContainer ? groupContainer.dataset.jsAdditionalGroup : input.name
      const value = parseInt(input.value, 10) || 0
      groupSums.set(groupKey, (groupSums.get(groupKey) || 0) + value)
    })

    inputFieldsAdditionalOptions.forEach((inputFieldAdditionalOptions) => {
      const amountInputRoot = inputFieldAdditionalOptions.closest('[data-js-amount-input]')
      const groupContainer = inputFieldAdditionalOptions.closest('[data-js-additional-group]')
      const groupKey = groupContainer ? groupContainer.dataset.jsAdditionalGroup : inputFieldAdditionalOptions.name
      const currentValue = parseInt(inputFieldAdditionalOptions.value, 10) || 0
      const siblingsSum = (groupSums.get(groupKey) || 0) - currentValue
      const effectiveMax = Math.max(0, maxValueForAdditionalOptions - siblingsSum)

      inputFieldAdditionalOptions.dataset.jsMax = String(effectiveMax)

      if (currentValue > effectiveMax) {
        inputFieldAdditionalOptions.value = String(effectiveMax)
        groupSums.set(groupKey, siblingsSum + effectiveMax)

        const valueSpan = amountInputRoot.querySelector('[data-js-amount-value]')
        if (valueSpan) {
          valueSpan.textContent = inputFieldAdditionalOptions.value
        }
      }

      const decreaseButton = amountInputRoot.querySelector('[data-js-decrease-amount]')
      const increaseButton = amountInputRoot.querySelector('[data-js-increase-amount]')
      const min = Number.parseInt(inputFieldAdditionalOptions.dataset.jsMin, 10)
      setAmountButtonStates(inputFieldAdditionalOptions, decreaseButton, increaseButton, effectiveMax, min)

      const limitHint = groupContainer?.querySelector('[data-js-additional-limit-hint]')
      if (limitHint) {
        const fieldValue = parseInt(inputFieldAdditionalOptions.value, 10) || 0
        if (fieldValue >= effectiveMax) {
          limitHint.removeAttribute('hidden')
        } else {
          limitHint.setAttribute('hidden', 'hidden')
        }
      }
    })
    initModal(fantissimaSelectMenuSection.querySelectorAll('[data-js-open-modal]'))
    checkMenuFormValidity()
  } else {
    fantissimaSelectMenuSection.setAttribute('hidden', 'hidden')
    fantissimaSelectAdditionalOptions.setAttribute('hidden', 'hidden')
    selectTicketAlert.removeAttribute('hidden')
    fantissimaSelectMenuAlert.removeAttribute('hidden')
  }

  const menuSelection = document.querySelector('[data-js-menu-per-person]')
  const menuSelectionContent = menuSelection.innerHTML
  const menuFieldset = menuFormRow.querySelectorAll('[data-js-menu-fieldset]')
  const fieldsetLength = Array.from(menuFieldset).length

  function addMenuSelection () {
    fantissimaSelectMenuAlert.removeAttribute('hidden')
    fantissimaSelectAdditionalOptions.setAttribute('hidden', 'hidden')
    const menuSelectionCount = fieldsetLength + 1
    let content = menuSelectionContent.replaceAll('§§id§§', String(menuSelectionCount))

    // replace index in form name attribute
    content = content.replaceAll(/(name=".*?\[.*?])(\[\d+?])/g,
      '$1[' + fieldsetLength + ']')

    menuFormRow.insertAdjacentHTML('beforeend', content)

    const newFakeSelect = menuFormRow.querySelectorAll('[data-js-fake-select]')[menuSelectionCount - 1]

    fakeSelect(newFakeSelect)
  }

  function removeMenuSelection () {
    menuFieldset[fieldsetLength - 1].remove()
  }

  function checkMenuFormValidity () {
    const menuSelects = menuFormRow.querySelectorAll('select')

    if (menuSelects.length > 0) {
      let isValid = true
      for (const i in menuSelects) {
        if (menuSelects[i].value === '') {
          isValid = false
          break
        }
      }

      const menuRequiredTextarea = menuFormRow.querySelectorAll('textarea[required]')
      for (const i in menuRequiredTextarea) {
        if (menuRequiredTextarea[i].value === '') {
          isValid = false
          break
        }
      }
      const addToCartButton = document.querySelector('[data-js-add-to-cart]')

      if (fantissimaSelectMenuSection.hasAttribute('hidden') === false && isValid) {
        fantissimaSelectMenuAlert.setAttribute('hidden', 'hidden')
        fantissimaSelectAdditionalOptions.removeAttribute('hidden')
        addToCartButton.removeAttribute('disabled')
      } else {
        fantissimaSelectMenuAlert.removeAttribute('hidden')
        fantissimaSelectAdditionalOptions.setAttribute('hidden', 'hidden')
      }

      if (isPrototype && isValid) {
        addToCartButton.addEventListener('click', function (event) {
          event.preventDefault()

          showModal(document.querySelector('[data-js-add-to-cart-success]'))
          resetAmountInputs()
        })
      }
    }
  }

  if (getTicketAmount() > fieldsetLength) {
    addMenuSelection()
  } else if (fieldsetLength && getTicketAmount() < fieldsetLength) {
    removeMenuSelection()
  }

  toggleFieldsets()

  if (window.fantissimaFormController) {
    window.fantissimaFormController.abort()
  }

  window.fantissimaFormController = new AbortController()

  fantissimaSelectMenuSection.querySelectorAll('select, input, textarea').forEach((formField) => {
    formField.addEventListener('change', checkMenuFormValidity, { signal: window.fantissimaFormController.signal })
  })

  fantissimaSelectMenuSection.querySelectorAll('textarea').forEach((formField) => {
    formField.addEventListener('input', checkMenuFormValidity, { signal: window.fantissimaFormController.signal })
  })
}
